var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', [_vm.title ? _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('Title', {
    attrs: {
      "text-start": "",
      "font-weight": 600,
      "font-size": 14,
      "title": _vm.title
    }
  })], 1) : _vm._e(), _vm.existingFiles.length < _vm.limit ? _c('v-col', {
    staticClass: "pt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-file-input', {
    attrs: {
      "accept": "application/pdf",
      "placeholder": "Выберите файл",
      "prepend-icon": "mdi-paperclip",
      "truncate-length": "35",
      "loading": _vm.loading,
      "disabled": _vm.loading || _vm.disabled,
      "multiple": "",
      "outlined": "",
      "rounded": "",
      "dense": "",
      "show-size": "",
      "error-messages": _vm.$errorMessages(_vm.$v.files)
    },
    on: {
      "click": function click($event) {
        return _vm.$v.files.$touch();
      }
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function fn(_ref) {
        var file = _ref.file,
            index = _ref.index,
            text = _ref.text;
        return [_c('v-chip', {
          attrs: {
            "color": "blue",
            "dark": "",
            "small": "",
            "close": ""
          },
          on: {
            "click:close": function clickClose($event) {
              return _vm.removeFile(file);
            }
          }
        }, [_vm._v(" " + _vm._s(text) + " ")])];
      }
    }], null, false, 997896377),
    model: {
      value: _vm.files,
      callback: function callback($$v) {
        _vm.files = $$v;
      },
      expression: "files"
    }
  })], 1) : _vm._e(), _vm.existingFiles.length ? _c('v-col', {
    staticClass: "pt-0",
    attrs: {
      "cols": "12"
    }
  }, [_vm.showTitleExistingFiles ? _c('Title', {
    attrs: {
      "text-start": "",
      "font-weight": 400,
      "font-size": 14,
      "title": "Загруженные файлы"
    }
  }) : _vm._e(), _vm._l(_vm.existingFiles, function (file, i) {
    return _c('v-chip', {
      key: i,
      staticClass: "mr-1",
      class: _vm.showTitleExistingFiles && 'mt-1',
      attrs: {
        "color": "deep-purple accent-4",
        "dark": "",
        "close": "",
        "small": ""
      },
      on: {
        "click:close": function clickClose($event) {
          return _vm.removeFile(file);
        }
      }
    }, [_vm._v(" " + _vm._s(file.originalName) + " ")]);
  })], 2) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }